<script>
import { useI18n } from "vue-i18n";
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  setup() {
    const { t } = useI18n();
    return { t };
  },
  methods: {
    emitUpdate(val) {
      this.$emit("update:modelValue", val);
    },
  },
};
</script>

<template>
  <v-checkbox
    class="mt-n4 mb-n5"
    :model-value="modelValue"
    @update:modelValue="emitUpdate"
    required
  >
    <template #label>
      <span style="white-space: normal">
        {{ t("login.acceptTerms") }}
        <RouterLink
          to="/privacy-policy"
          style="color: blue; cursor: pointer; text-decoration: underline"
          @click.stop
        >
          {{ t("login.privacyPolicy") }}
        </RouterLink>
        {{ " " + t("common.and") + " " }}
        <RouterLink
          to="/privacy-policy"
          style="color: blue; cursor: pointer; text-decoration: underline"
          @click.stop
        >
          {{ t("login.termsOfUse") }}
        </RouterLink>
      </span>
    </template>
  </v-checkbox>
</template>
